import * as yup from 'yup';

export const commonCreateStandardProposalValidation: { [x: string]: any; } = {
    companyCode: yup.string().required("Missing."),
    proposalCreatedByMethod: yup.string().required("Missing."),
    effectiveDate: yup.date().required("Missing."),
    expiryDate: yup.date().required("Missing."),
    currencyCode: yup.string().required("Missing."),
    tariffNatureList: yup.array().min(1, "Missing.").required("Missing."),
};
export const commonCreateTariffItemValidation: { [x: string]: any; } = {
    tariffType: yup.string().required("Missing."),
    tariffCode: yup.string().required("Missing."),
};
export const commonCreateTempSaveTariffItemTierValidation: { [x: string]: any; } = {
    forevery: yup.number().required("Missing."),
    cycle: yup.number().required("Missing."),
    uom: yup.string().required("Missing."),
    rate: yup.number().required("Missing."),
    minimum: yup.number().required("Missing."),
};
export const commonCopyEditNewProposalNoValidation: { [x: string]: any; } = {
    companyCode: yup.string().required("Missing."),
    proposalCreatedByMethod: yup.string().required("Missing."),
    effectiveDate: yup.date().required("Missing."),
    expiryDate: yup.date().required("Missing."),
    currencyCode: yup.string().required("Missing."),
};
export const commonCopyEditProposalNoValidation: { [x: string]: any; } = {
    companyCode: yup.string().required("Missing."),
    proposalNo: yup.string().required("Missing."),
};
export const commonCopyToEditPercentageValidation: { [x: string]: any; } = {
    tariffType: yup.string().required("Missing."),
    chargePercentage: yup.number().required("Missing."),
    roundMethod: yup.string().required("Missing."),
    decimalPlace: yup.string().required("Missing."),
};

export const createTempSaveTariffItemTierValidation: { [x: string]: any; } = {
    ...commonCreateTempSaveTariffItemTierValidation,
};
export const createTariffItemValidation: { [x: string]: any; } = {
    ...commonCreateTariffItemValidation,
};
export const createStandardProposalValidation: { [x: string]: any; } = {
    ...commonCreateStandardProposalValidation,
};
export const copyEditNewProposalNoValidation: { [x: string]: any; } = {
    ...commonCopyEditNewProposalNoValidation,
};
export const copyEditProposalNoValidation: { [x: string]: any; } = {
    ...commonCopyEditProposalNoValidation,
};
export const copyToEditPercentageValidation: { [x: string]: any; } = {
    ...commonCopyToEditPercentageValidation,
};

export const createTempSaveTariffItemTierValidationSchema = yup.object().shape(createTempSaveTariffItemTierValidation);
export const createTariffItemValidationSchema = yup.object().shape(createTariffItemValidation);
export const createStandardProposalValidationSchema = yup.object().shape(createStandardProposalValidation);
export const copyEditNewProposalNoValidationSchema = yup.object().shape(copyEditNewProposalNoValidation);
export const copyEditProposalNoValidationSchema = yup.object().shape(copyEditProposalNoValidation);
export const copyToEditPercentageValidationSchema = yup.object().shape(copyToEditPercentageValidation);

